(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('payoutService', payoutService);

  function payoutService(
    
  ) {
    'ngInject';

    const service = {
      sanitizePayoutsForDisplay: sanitizePayoutsForDisplay,
      sanitizePayout: sanitizePayout,
      sanitizePayoutsForComparison: sanitizePayoutsForComparison
    };

    return service;

    // This removes the negative amounts from payoutAmount and revSharePercentage
    function sanitizePayoutsForDisplay(payouts) {
      return _.map(payouts, function (payout) {
        return sanitizePayout(payout);
      });
    }

    function sanitizePayoutsForComparison(payouts) {
      return _.map(payouts, function (payout) {
        return _sanitizePayoutForComparison(payout);
      });
    }

    function sanitizePayout(payout) {
      if (!payout) {
        return;
      }

      if (payout.payoutAmount === -1) {
        delete payout.payoutAmount;
      }
      if (payout.revSharePercentage === -1) {
        delete payout.revSharePercentage;
      }
      return payout;
    }

    function _sanitizePayoutForComparison(payout) {
      const newPayout = angular.copy(payout);
      delete newPayout.showPayoutSettingsForm;
      return newPayout;
    }
    
  }
})();
